export default __webpack_public_path__ + "static/media/bazzle_vm_3.23601cc4.png";